import merge from 'lodash/merge'
import { namespaceLocaleObj } from 'vue_features/shared/helpers/i18n_helper'
import { common, layouts } from 'vue_features/shared/i18n'
import { searchFormMessages } from 'vue_features/search/i18n'
import HeaderFeature from './components/HeaderFeature'

const messages = merge(
  {},
  namespaceLocaleObj(common, 'common'),
  namespaceLocaleObj(layouts, 'layouts'),
  searchFormMessages,
)

export default function () {
  return { component: HeaderFeature, messages }
}

